import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_ACCOUNT_ME_QUERY_KEY } from "../../../components/auth/api/authApi";
import { GET_SECTIONS_QUERY_KEY } from "../../root/api/rootScreenApi";
import { postUpdateProfile, ProfilePayload } from "../api/profileApi";
import { useSettingsToast, extractErrorMessage } from "./useSettingsMutations";

export function useProfileMutation() {
  const toast = useSettingsToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ProfilePayload) => postUpdateProfile(payload),
    onMutate: async (payload) => {
      await queryClient.cancelQueries({ queryKey: GET_ACCOUNT_ME_QUERY_KEY });
      const previous = queryClient.getQueryData(GET_ACCOUNT_ME_QUERY_KEY);
      queryClient.setQueryData(GET_ACCOUNT_ME_QUERY_KEY, (old: any) => {
        if (!old?.data?.payload?.results?.user) return old;
        return {
          ...old,
          data: {
            ...old.data,
            payload: {
              ...old.data.payload,
              results: {
                ...old.data.payload.results,
                user: { ...old.data.payload.results.user, ...payload },
              },
            },
          },
        };
      });
      return { previous };
    },
    onSuccess: (response, payload) => {
      queryClient.setQueryData(GET_ACCOUNT_ME_QUERY_KEY, response);
      if ("show_mature_content" in payload) {
        queryClient.invalidateQueries({ queryKey: [GET_SECTIONS_QUERY_KEY] });
      }
      toast.success("Profile updated");
    },
    onError: (error: any, _payload, context) => {
      if (context?.previous) {
        queryClient.setQueryData(GET_ACCOUNT_ME_QUERY_KEY, context.previous);
      }
      toast.error("Failed to update profile", extractErrorMessage(error));
    },
  });
}
